angular.module("vgresiduos").controller("CreateActionPlanCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";
		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/plano-de-acao/${$stateParams.auditId}/novo`
			);
		};
	}
]);
